import { GraphSchema } from '@camelot/server';

export enum PurchaseOrderType {
  Unknown = 0,
  Supply = 1,
  Subcontracting = 2,
}

export enum PurchaseOrderStatus {
  Unknown = 0,
  Draft = 1,
  PendingValidation = 2,
  Validated = 3,
  Cancelled = 4,
}

export enum PurchaseOrderExecutionStatus {
  Unknown = 0,
  NotStarted = 1,
  PartiallyReceived = 2,
  FullyReceived = 3,
}

export enum PurchaseOrderDeliveryType {
  Unknown = 0,
  OnSite = 1,
  Warehouse = 2,
  StorePickup = 3,
}

export enum PurchaseOrderDeliveryMode {
  Unknown = 0,
  Internal = 1,
  Subcontractor = 2,
  Supplier = 3,
  SiteCost = 4,
}

export interface PurchaseOrder {
  id: string;
  reference: string | null;
  orderNumber: number | null;
  externalId: string | null;
  supplierReference: string | null;
  type: PurchaseOrderType;
  status: PurchaseOrderStatus;
  executionStatus: PurchaseOrderExecutionStatus;
  description: string | null;
  supplierId: string;
  supplierContactPersonId: string | null;
  companyId: string;
  departmentId: string | null;
  projectId: string | null;
  preferredDeliveryDate: string | null;
  deliveryType: PurchaseOrderDeliveryType;
  deliveryAddressId: string | null;
  executionStartDate: string | null;
  executionEndDate: string | null;
  retentionPercentage: number | null;
  specificConditionsHtml: string | null;
  validationDate: string | null;
  sentDate: string | null;
  acknowledgedDate: string | null;
  parentId: string | null;
  parentReference: string | null;
  amendmentNumber: number | null;
  budgetLineId: string | null;
  budgetReference: string | null;
  rowsCount: number;
  createdTime: string;
  updatedTime: string;
}

export const purchaseOrderProps = new GraphSchema<PurchaseOrder>([
  'id',
  'reference',
  'orderNumber',
  'externalId',
  'supplierReference',
  'type',
  'status',
  'executionStatus',
  'description',
  'supplierId',
  'supplierContactPersonId',
  'companyId',
  'departmentId',
  'projectId',
  'preferredDeliveryDate',
  'deliveryType',
  'deliveryAddressId',
  'executionStartDate',
  'executionEndDate',
  'retentionPercentage',
  'specificConditionsHtml',
  'validationDate',
  'sentDate',
  'acknowledgedDate',
  'parentId',
  'parentReference',
  'amendmentNumber',
  'budgetLineId',
  'budgetReference',
  'rowsCount',
  'createdTime',
  'updatedTime',
]);

export interface PurchaseOrderCreationPayload {
  type: number;
  supplierId: string;
  companyId: string;
  departmentId?: string | null;
  projectId?: string | null;
  description?: string | null;
  externalId?: string | null;
  supplierReference?: string | null;
  supplierContactPersonId?: string | null;
  preferredDeliveryDate?: string | null;
  deliveryType: number;
  deliveryAddressId?: string | null;
  executionStartDate?: string | null;
  executionEndDate?: string | null;
  retentionPercentage?: number | null;
  specificConditionsHtml?: string | null;
}

export interface PurchaseOrderModifierPayload extends Partial<PurchaseOrderCreationPayload> {
  purchaseOrderId: string;
  updatedFields: string[];
}

export interface PurchaseOrderAmendmentCreationPayload {
  parentId: string;
  description?: string | null;
  supplierReference?: string | null;
  supplierContactPersonId?: string | null;
  departmentId?: string | null;
  projectId?: string | null;
  preferredDeliveryDate?: string | null;
  deliveryType: number;
  deliveryAddressId?: string | null;
  executionStartDate?: string | null;
  executionEndDate?: string | null;
  retentionPercentage?: number | null;
  specificConditionsHtml?: string | null;
}
